import { Modal, Table, Typography} from "antd"
import { useSelector } from "react-redux"
import { TableLoader } from "../../../shared"
import { methodUrlType } from "../../../shared/lookups"
import { UpdatePortalDrawer } from "../Drawers"
import { useState } from "react"
import { ActionButton } from "../../PageComponents"
import { EditOutlined } from "@ant-design/icons"
const {Text}= Typography

const ViewPortalsModal = ({visible, onClose }) => {

    const {portals, portalsLoading}= useSelector(state => state?.addEditBox)
    const [visibleDrawer, setVisibleDrawer]= useState(false)

    const columns = [
        {
            title: <Text>Name</Text>,
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: <Text>Portal Type</Text>,
            dataIndex: 'methodType',
            key: 'methodType',
            render: col => <Text>{methodUrlType?.find(fin => fin?.id === parseInt(col))?.name}</Text>
        },
        {
            title: <Text>Url</Text>,
            dataIndex: 'url',
            key: 'url',
            width: '400px'
        },
        {
            title: <Text>Username</Text>,
            dataIndex: 'userName',
            key: 'userName',
            render: col => <Text>{col || "-"}</Text>
        },
        {
            title: <Text>Action</Text>,
            key: 'action',
            fixed:'right',
            width: 120,
            render: (_, row) => (
                <ActionButton
                    title='Edit Box'
                    icon={<EditOutlined className='green-color'/>}
                    onClick={()=>{setVisibleDrawer(row)}}
                />
            )
        }
    ]
 
  return (
    <div>
        <Modal
            title={visible + " Portals"}
            onClose={onClose}
            onCancel={onClose}
            open={visible}
            width={'80%'}
            centered
            footer={null}
        >
            <Table 
                columns={columns} 
                dataSource={portals} 
                pagination={false}
                loading={
                    {
                        ...TableLoader,
                        spinning: portalsLoading
                    }
                }
            />  
        </Modal>
        <UpdatePortalDrawer
            open={visibleDrawer}
            onClose={()=> setVisibleDrawer(false)}
        />
    </div>
  )
}

export {ViewPortalsModal}